"use client";
import React from "react";
import { SecondSectionCards } from "./SecondSectionTabs";
import { useFetchCompanyInfo } from "src/app/lib/fetchCompanyInfo";

const SecondSection = () => {
  const { data, isLoading } = useFetchCompanyInfo();

  const companyName = isLoading
    ? "Loading..."
    : data?.companyInfo?.name || "A & Z Properties Limited";

  return (
    <section className="py-5 text-primary">
      <div className="wrapper">
        <h1 className="leading-[6rem] text-center">
          Welcome To <span className="text-2xl block">{companyName}</span>
        </h1>
        {/* <GroupHeader subheader={companyName} header="Welcome To" /> */}
        <SecondSectionCards />
      </div>
    </section>
  );
};

export default SecondSection;
